<template>
  <main id="vendors-list" class="site-main">
    <div class="grid-container">
      <div class="page-header grid-x grid-padding-x align-middle">
        <div class="cell auto">
          <h1 class="page-header__title">Orders</h1>
        </div>
      </div>

      <div class="panel no-padding">
        <searchBar placeholder="Search orders" @sort="sort" :value="searchValue"
                   @search="search"></searchBar>

        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <pagination :prev="prev" :next="next" :start="start" :end="end" :total="total"
                        @paginate="paginate"></pagination>

            <tableList :header="tableHeader" :data="tableData" :loading="loading"
                       @post="go" @sort="orderBy"></tableList>

            <pagination :prev="prev" :next="next" :start="start" :end="end" :total="total"
                        @paginate="paginate"></pagination>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'

import moment from 'moment'

export default {
  name: 'ordersList',
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/orders/',
      sort: '-processed_at',
      tableHeader: {
        currentSort: 'name',
        data: [
          {
            label: 'Order',
            class: 'full',
            sort: 'name',
            sortStart: '-'
          },
          {
            label: 'Date',
            class: 'large',
            sort: 'processed_at',
            sortStart: '-'
          },
          {
            label: 'Customer',
            class: 'large',
            sort: 'customer_name'
          },
          {
            label: 'Payment',
            class: 'medium',
            sort: 'financial_status'
          },
          {
            label: 'Fulfillment',
            class: 'medium',
            sort: 'fulfillment_status'
          },
          {
            label: 'Total',
            sort: 'total_price',
            sortStart: '-'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    go: function (id) {
      this.$router.push('/orders/' + id)
    },
    buildTable () {
      for (let i = 0; i < this.data.length; i++) {
        let financialStatus = 'success'
        let fulfillmentStatus = 'success'

        if (this.data[i].financial_status === 'pending' ||
          this.data[i].financial_status === 'partially_paid' ||
          this.data[i].financial_status === 'partially_refunded' ||
          this.data[i].financial_status === 'authorized') {
          financialStatus = 'warning'
        } else if (this.data[i].financial_status === 'voided' ||
          this.data[i].financial_status === 'refunded') {
          financialStatus = 'alert'
        }

        if (this.data[i].fulfillment_status === 'partial') {
          fulfillmentStatus = 'warning'
          this.data[i].fulfillment_status = 'Partially Fulfilled'
        } else if (this.data[i].fulfillment_status === 'restocked' ||
          this.data[i].fulfillment_status === null) {
          fulfillmentStatus = 'alert'
        }

        if (this.data[i].fulfillment_status === null) {
          this.data[i].fulfillment_status = 'Unfulfilled'
        }

        let customerColVal = this.data[i].customer_name

        if (this.$store.state.shop.myshopify_domain === 'new-dimension-books.myshopify.com') {
          customerColVal = this.data[i].customer_company
        }

        this.tableData.push({
          post: this.data[i].id,
          data: [
            {
              value: this.data[i].name,
              class: 'full focus-text'
            },
            {
              value: moment(this.data[i].processed_at).format('MMM D, YYYY [at] h:mma'),
              class: 'large'
            },
            {
              class: 'large',
              value: customerColVal
            },
            {
              value: this.formatText(this.data[i].financial_status),
              class: 'medium',
              span: 'label ' + financialStatus
            },
            {
              value: this.formatText(this.data[i].fulfillment_status),
              class: 'medium',
              span: 'label ' + fulfillmentStatus
            },
            {
              value: this.formatMoney(this.data[i].total_price)
            }
          ]
        })
      }
    }
  },
  created () {
    if (this.$store.state.shop.myshopify_domain === 'new-dimension-books.myshopify.com') {
      this.tableHeader.data[2].label = 'Company'
    }
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

</style>



// WEBPACK FOOTER //
// src/pages/orders/list.vue